// extracted by mini-css-extract-plugin
export default {"header":"Header_header__RJjxy","logoButton":"Header_logoButton__6TaCZ","nav":"Header_nav__-hWnK","active":"Header_active__Fw7lv","right":"Header_right__32HM9"};